import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=1f588d0d&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=1f588d0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f588d0d",
  null
  
)

export default component.exports